










































































import {Component, Vue, Prop} from 'vue-property-decorator'
import {$, ID, error, successAndPush, sleep, IResource, ObjectCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {ItrackCollection, cnpj} from '@/helpers'
import MotoristaEResponsaveisRequest from '@/model/request/MotoristaEResponsaveisRequest'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'
import moment from 'moment'
import TipoVeiculo from '@/model/resource/TipoVeiculo'
import { TipoVeiculoData } from '@/helpers/TipoVeiculoData'

interface TipoVeiculoResponse {
  items: TipoVeiculo[];
}

const sha1 = require('sha1')

const metaInfo = () => ({
  title: $.t('view.persist.driverPersist.title'),
})

@Component({
  metaInfo,
})
export default class DriverPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID
  listTovehicleType: TipoVeiculo[] = []

  AppConfig = AppConfig
  Helper = Helper

  motoristaReq = new MotoristaEResponsaveisRequest()
  cpfChecked = false
  allFilial = ItrackCollection.allFilial
  allTipoVeiculo: any = null
  selectedItemTipoVeiculo: Object = []

 async created() {
    const dataTipoVeiculo = await ItrackCollection.allTipoVeiculo.query()
    const listTipoVeiculo = dataTipoVeiculo.data as unknown as TipoVeiculoResponse;
    this.allTipoVeiculo = new ObjectCollection(listTipoVeiculo.items.map((item: TipoVeiculo) => ({
      $id: item.idTipoVeiculo,
      $tag: item.nome
    })))
    this.motoristaReq.motorista.tipoVeiculoFk = this.motoristaReq.motorista.tipoVeiculoData.idTipoVeiculo

    TipoVeiculoData.data =  this.allTipoVeiculo
  }

  async mounted() {
    if (this.id) {
      await this.motoristaReq.motorista.find(this.id)
    }
    await this.allFilial.query()
    this.allFilial.items.forEach((item: Responsavel) => {
      let nomeFantasia = ''
      if (item.nomeFantasia) {
        nomeFantasia = `${$.filter.truncate(item.nomeFantasia || '', 20)} - `
      }

      item.$tag = `${nomeFantasia}${Helper.cnpj(item.cnpj)}`
    })
    $.await.done('findMotorista')
  }

  get resourceSelect() {
    return {
      tipoVeiculoFk: this.allTipoVeiculo.nullableItems(),
      marcaVeiculo: ItrackCollection.allMarcaVeiculo.nullableItems(),
      tipoCarroceria: ItrackCollection.allTipoCarroceria.nullableItems(),
    }
  }

  async checkIfCpfExist() {
    await this.motoristaReq.motorista.checkExists(this.motoristaReq.motorista.cpf, 'checkIfCpfExist')
    this.cpfChecked = true
  }

  async persist() {
    // await this.motoristaReq.motorista.endereco.populateLatLng()

    if (this.motoristaReq.motorista.dataNascimento) {
      this.motoristaReq.motorista.dataNascimento = moment(this.motoristaReq.motorista.dataNascimento)
          .utcOffset('-03:00', true)
          .format()
    }

    this.motoristaReq.motorista.senha = sha1((Math.random() * 1e32).toString(36))
    await this.motoristaReq.motorista.validate()

    if (Helper.getPermitirRoterizacao() ) {
        try {
            await this.motoristaReq.motorista.jornadaMotorista.validateJornadaDias()
        } catch (e) {
            this.$snotify.error($.t('view.persist.driverPersist.errorJorneyEmpty'))
            return
        }
    }
    const instanceTipoVeiculo = new TipoVeiculo()
    instanceTipoVeiculo.idTipoVeiculo = this.motoristaReq.motorista.tipoVeiculoFk
    this.motoristaReq.motorista.tipoVeiculoData = instanceTipoVeiculo
    this.motoristaReq.motorista.tipoVeiculoFkResource = instanceTipoVeiculo
    this.motoristaReq.motorista.tipoVeiculoFk = instanceTipoVeiculo.idTipoVeiculo

    await this.motoristaReq.save()
    successAndPush('system.success.persist', '/manage/driver/list')
  }
}
